import { render, staticRenderFns } from "./contactsList.vue?vue&type=template&id=2867b644&"
import script from "./contactsList.vue?vue&type=script&lang=js&"
export * from "./contactsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports